module.exports = __webpack_public_path__ + "static/media/Udawalawa.7084a0b0.png";